import { render, staticRenderFns } from "./parentNotice.vue?vue&type=template&id=3f396196&scoped=true"
import script from "./parentNotice.vue?vue&type=script&lang=js"
export * from "./parentNotice.vue?vue&type=script&lang=js"
import style0 from "./parentNotice.vue?vue&type=style&index=0&id=3f396196&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f396196",
  null
  
)

export default component.exports